import { useRuntimeVariables } from 'app-kit'
import { AuthedAxiosRequests, useGeckoAuth } from 'features/auth'
import React from 'react'

export interface SendSlackMessageRequest {
  channel_id: string
  site_name: string
  unit_name: string
  component_name: string
  component_slug: string
  inspection_slug: string
  forecast_link: string
  sales_representative: string | undefined
  data_lead: string | undefined
  supervisor: string | undefined
  operations_data_lead: string | undefined
  qa_qc_lead: string | undefined
}

export function useSlackAPI() {
  const { ALERTS_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()

  return React.useMemo(() => {
    return {
      getSlackChannels: () => getSlackChannels(ALERTS_URL, axios),
      getSlackUsers: () => getSlackUsers(ALERTS_URL, axios),
      sendSlackNotification: (
        slug: string,
        request: SendSlackMessageRequest,
        finalApproval?: boolean
      ) =>
        sendSlackNotification(slug, ALERTS_URL, axios, request, finalApproval),
    }
  }, [ALERTS_URL, axios])
}

async function getSlackChannels(alertsUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${alertsUrl}/api/v1/publisher/get-slack-channels`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function getSlackUsers(alertsUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${alertsUrl}/api/v1/publisher/get-slack-users`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function sendSlackNotification(
  slug: string,
  alertsUrl: string,
  axios: AuthedAxiosRequests,
  request: SendSlackMessageRequest,
  finalApproval?: boolean
) {
  if (finalApproval) {
    return await axios.post(
      `${alertsUrl}/api/v1/publisher/${slug}/send-slack-notification-ready-to-publish`,
      request,
      { headers: { 'Content-Type': 'application/json' } }
    )
  } else {
    return await axios.post(
      `${alertsUrl}/api/v1/publisher/${slug}/send-slack-notification`,
      request,
      { headers: { 'Content-Type': 'application/json' } }
    )
  }
}
